'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable flowtype/require-valid-file-annotation */

var SHADOW_OPACITY = 0.1;
var SHADOW_STEP = 0.3;

var createShadow = exports.createShadow = function createShadow() {
  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + SHADOW_OPACITY + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + SHADOW_OPACITY + ')'].join(',');
};

var createShadowLevel = exports.createShadowLevel = function createShadowLevel(level) {
  var step = (level - 1) * SHADOW_STEP;
  var increment = function increment(v) {
    return Math.round(v + step);
  };
  return createShadow(0, 2, increment(10), 0, 0, 0, increment(3), 0);
};

var range = function range(start, end) {
  return ' '.repeat(end - start + 1).split('').map(function (v, i) {
    return i + start;
  });
};

var shadows = ['none'].concat(_toConsumableArray(range(1, 24).map(createShadowLevel)));

exports['default'] = shadows;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/shadows.js
// module id = 1338
// module chunks = 32